import { Button, Popover, Typography } from "@mui/material";
import { TRIAL_STAGES } from "Utils/trialStatus";
import styles from "./TrialStatus.module.scss";

const formatDate = (date) =>
  date
    ? date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "";

const getStatusCopy = ({ stage, daysLeft, trialEndsAt }) => {
  const endDate = formatDate(trialEndsAt);
  switch (stage) {
    case TRIAL_STAGES.EXPIRED:
      return `Your free trial ended on ${endDate}. Premium features are paused until you choose a plan.`;
    case TRIAL_STAGES.LAST_DAY:
      return "Your free trial ends today. Upgrade to keep your lists and premium features.";
    default:
      return `You have ${daysLeft} ${daysLeft === 1 ? "day" : "days"} left on your free trial (ends ${endDate}).`;
  }
};

const TITLE_ID = "trial-status-popover-title";

const TrialStatusPopover = ({ anchorEl, onClose, trial, onUpgrade }) => {
  const isExpired = trial?.stage === TRIAL_STAGES.EXPIRED;

  return (
    <Popover
      open={Boolean(anchorEl) && Boolean(trial?.isTrial)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          className: styles.popover,
          role: "dialog",
          "aria-labelledby": TITLE_ID,
        },
      }}
    >
      <Typography id={TITLE_ID} component="h2" className={styles.popoverTitle}>
        {isExpired ? "Trial ended" : "Free trial"}
      </Typography>
      <Typography className={styles.popoverCopy}>
        {trial?.isTrial ? getStatusCopy(trial) : null}
      </Typography>
      <Button
        variant="contained"
        disableElevation
        className={styles.primaryButton}
        onClick={onUpgrade}
        fullWidth
      >
        {isExpired ? "Choose a plan" : "Upgrade now"}
      </Button>
    </Popover>
  );
};

export default TrialStatusPopover;
